import {
    GET_PARKING_LIST_REQUEST,
    LOAD_PARKING_DATA_REQUEST,
    LOAD_PARKING_SPOTS_TABLE_DATA_REQUEST,
    LOAD_PARKING_SPOTS_GRAPH_DATA_REQUEST,
    LOAD_SEARCH_FIELDS_DATA_REQUEST,
    TABLE_SEARCH_FIELD_CHANGED,
    TABLE_SEARCH_FIELD_CLEAN_ALL,
    GRAPH_SEARCH_FIELD_CHANGED,
    GRAPH_SEARCH_FIELD_CLEAN_ALL,
    //GRAPH_SERIES_CHANGED,
    RESET_SELECTED_PARKING,
    OPEN_SPOT_CONFIGURATION_MODAL,
    CLOSE_SPOT_CONFIGURATION_MODAL,
    CHANGE_SELECTED_CATEGORY,
    CHANGE_SPOT_CATEGORY_REQUEST,
    COLLAPSE_SPOTS_INFO_CATEGORIES
} from "./actionTypes";

const fetchAvailableParkings = () => ({
    type: GET_PARKING_LIST_REQUEST
});

const fetchParkingData = parkingId => ({
    type: LOAD_PARKING_DATA_REQUEST,
    parkingId
});

const fetchTableData = (parkingId, searchFields) => ({
    type: LOAD_PARKING_SPOTS_TABLE_DATA_REQUEST,
    parkingId,
    searchFields
});

const fetchGraphData = (parkingId, searchFields) => ({
    type: LOAD_PARKING_SPOTS_GRAPH_DATA_REQUEST,
    parkingId,
    searchFields
});

const fetchSearchFieldsData = parkingId => ({
    type: LOAD_SEARCH_FIELDS_DATA_REQUEST,
    parkingId
});

const handleTableSearchFieldValueChanged = (fieldId, value) => ({
    type: TABLE_SEARCH_FIELD_CHANGED,
    payload: {
        fieldId,
        value
    }
});

const handleTableSearchFieldCleanAll = () => ({
    type: TABLE_SEARCH_FIELD_CLEAN_ALL
});

const handleGraphSearchFieldValueChanged = (fieldId, value) => ({
    type: GRAPH_SEARCH_FIELD_CHANGED,
    payload: {
        fieldId,
        value
    }
});

const handleGraphSearchFieldCleanAll = () => ({
    type: GRAPH_SEARCH_FIELD_CLEAN_ALL
});

/*const handleGraphSeriesClicked = clickedSeries => ({
    type: GRAPH_SERIES_CHANGED,
    payload: clickedSeries
});*/

const resetSelectedParking = () => ({
    type: RESET_SELECTED_PARKING
})

const openConfigurationModal = slotId => ({
    type: OPEN_SPOT_CONFIGURATION_MODAL,
    payload: slotId
})

const closeConfigurationModal = () => ({
    type: CLOSE_SPOT_CONFIGURATION_MODAL
})

const changeSelectedCategory = category => ({
    type: CHANGE_SELECTED_CATEGORY,
    payload: category
})

const submitNewCategory = (slotId, category, selectedSlotName, slotsData) => ({
    type: CHANGE_SPOT_CATEGORY_REQUEST,
    slotId,
    category,
    selectedSlotName,
    slotsData
})

const collapseCategorySlotsData = () => ({
    type: COLLAPSE_SPOTS_INFO_CATEGORIES
})

export default {
    fetchAvailableParkings,
    fetchParkingData,
    fetchTableData,
    fetchGraphData,
    fetchSearchFieldsData,
    handleTableSearchFieldValueChanged,
    handleTableSearchFieldCleanAll,
    handleGraphSearchFieldValueChanged,
    handleGraphSearchFieldCleanAll,
    //handleGraphSeriesClicked,
    resetSelectedParking,
    collapseCategorySlotsData,
    openConfigurationModal,
    closeConfigurationModal,
    changeSelectedCategory,
    submitNewCategory
}